import React, { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { FaEarthAmericas } from "react-icons/fa6";
import { FiFacebook } from "react-icons/fi";
import { IoSearchOutline, IoWarning } from "react-icons/io5";
import "../../css/items.scss";
import { serverInstance } from "../../service/axios";
import Dimmer from "../shared/Dimmer";
import "./schools.scss";

const Schools = ({ data, language }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allItems, setAllItems] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    
    serverInstance.get("/app/schools")
      .then(res => {
        let data = res.data.items.filter(item => !item.test)
        setAllItems(data)
        setFilteredData(data)
        setErrorMsg("");
        setLoading(false);
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      })
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    const filtered = allItems.filter((item) => {
      return (
        (item.name && item.name.toLowerCase().includes(term)) ||
        (item.name_en && item.name_en.toLowerCase().includes(term)) ||
        (item.address_town && item.address_town.toLowerCase().includes(term)) ||
        (item.address_state && item.address_state.toLowerCase().includes(term)) ||
        (item.address_line_1 && item.address_line_1.toLowerCase().includes(term)) ||
        (item.address_line_2 && item.address_line_2.toLowerCase().includes(term))
      );
    });
    
    setFilteredData(filtered);
  };

  return (
    <div className='items-container' id='schools'>
      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>

          <div className="input-container">
            <input
              type='text'
              placeholder={data.placeholder}
              value={searchTerm}
              onChange={handleSearch}
              className=''
            />
            <button className="search-btn">
              <IoSearchOutline size={18} />
            </button>
          </div>
        </div>
      </section>

      <div className='main-container'>
        {loading ? <Dimmer /> : null}

        {errorMsg ? <div className="error-msg">
          <IoWarning/>
          &nbsp;
          {errorMsg}
        </div> : null}

        {!loading && filteredData.length === 0 ?
        <div className="no-data">{data.noData}</div>
        :
        !loading && filteredData.length > 0 ?
        <div className="search-result">
          <div className="count">{data.searchResults} {filteredData.length}</div>

          <div className="items">
            {filteredData.map((item) => (
              <div key={"school-" + item.id} className='school-item'>
                <div className="school-img">
                  {item.logo_url ?
                  <img src={`https://lingo-portal-assets.s3.ap-northeast-2.amazonaws.com/${item.logo_url}`}/>
                  : null}
                </div>
                <div className='school-info'>
                  <div className="school-name">{ language === "en" && item.name_en ? item.name_en : item.name}</div>
                  <p className='text-muted'>
                    {language === "en" && item.address_line_1_en ?
                    [item.address_line_1_en, item.address_line_2_en, item.address_town_en, item.address_state_en].filter(part => part && part.trim()).join(', ')
                    :
                    [item.address_line_1, item.address_line_2, item.address_town, item.address_state].filter(part => part && part.trim()).join(', ')}
                  </p>
                  <div className="links">
                    {item.phone ?
                    <div className="contact">
                      <FaPhoneAlt size={16} className='icons' color="black" />
                      <span className='text-dark'>{item.phone}</span>
                    </div> : null}
                    { item.web_link ?
                    <a className="contact" href={item.web_link} target="blank">
                      <FaEarthAmericas size={16} className='icons' color="black"/>
                      <span className='text-dark'>{item.web_link}</span>
                    </a> : null}
                    { item.map_link ?
                    <a className="contact"  href={item.map_link} target="blank">
                      <FaMapMarkerAlt size={16} className='icons' color="black"/>
                      <span className='text-dark'>Google map</span>
                    </a> : null}
                    { item.social_link ?
                    <a className="contact"  href={item.social_link} target="blank">
                      <FiFacebook size={16} className='icons' color="black"/>
                      <span className='text-dark'>{item.social_link}</span>
                    </a> : null}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        : null
        }
      </div>
    </div>
  );
};

export default Schools;
